
<template lang="pug">
  .main-Layouts(v-if="affiliate")
    y-dialog(v-model="newUpdate" persistent width="340")
      v-card
        v-card-title(style="height:56px;")
          .h6.basic800--text Latest version is available
        v-card-text
          .p2.primary400--text For your convenience, please refresh the page to prevent errors from happening
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='newUpdate = false')
            .button-Aa-small.primary400--text Later
          v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="reload")
            .button-AA-small.basic100--text Refresh Now
    .affiliate-views
      affiliate-nav-bar(:propAffiliate.sync="affiliate" :propNotificationCount.sync="notificationCount" v-intersect="onIntersect")
      v-container(v-if="isReloading")
        v-layout.my-6
          v-row.fill-height.ma-0(align='center' justify='center')
            div.text-center
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
              .s1.mt-4 Refreshing...
      router-view(v-else :propAffiliate.sync="affiliate")
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/browser'
import AffiliateNavBar from '@/components/AffiliateNavBar.vue'
import Cookies from 'js-cookie'

Vue.mixin({
  methods: {
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    }
  }
})

export default {
  name: 'AffiliateHome',
  components: { AffiliateNavBar },
  data: () => ({
    isReloading: false,
    newUpdate: false,
    isAtTop: false,
    pStart: {x: 0, y:0},
    pStop: {x: 0, y:0},
    affiliate: null,
    notificationCount: null,
    permissions: {
      "/affiliate/dashboard": true,
      "/affiliate/profile": true,
      "/affiliate/notifications": true
    }
  }),
  computed: {
    ...mapState('user', ['user']),
  },
  watch: {
    '$route.path' (val) {
      window.pageYOffset = 0
      document.documentElement.scrollTop = 0
      if (!this.checkAuth(val)) {
        this.$router.push('/companies')
        return
      }
    }
  },
  mounted () {
    if (this.$route.path == '/affiliate' || this.$route.path == '/affiliate/') {
      this.$router.push('/affiliate/dashboard')
    }
    const cookieUser = Cookies.get('user')
    if (!cookieUser) {
      this.$store.commit('ui/setRedirectPath', this.$route.path)
      this.goToSignIn()
    }

    if (!this.user) {
      let user = JSON.parse(cookieUser)
      this.$store.commit('user/setUser', user)
    }

    Sentry.configureScope(scope => {
      scope.setUser({ 'id': this.user.id, 'email': this.user.email })
    })
    this.checkAffiliation()
    if (this.$isMobile) {
      window.addEventListener('touchstart', (e) => { this.swipeStart(e) }, false)
      window.addEventListener('touchend', (e) => { this.swipeEnd(e) }, false)
    }
    this.checkNotifications()
  },
  methods: {
    ...mapActions(['showMessage']),
    checkAffiliation () {
      this.$axios.get('/partners/')
        .then(resp => {
          this.affiliate = resp.data
        })
        .catch(() => {
          this.$router.push('/companies')
        })
    },
    checkAuth (val) {
      if (this.permissions[val]) {
        return true
      }
    },
    checkNotifications () {
      this.$axios.get(`/notifications/partner_commission?page_size=-1`)
        .then((response) => {
          if (response.data && response.data.results && response.data.results.length > 0) {
            this.notificationCount = response.data.count
          }
        })
        .catch(() => {})
    },
    goToSignIn () {
      if (this.$subdomain) {
        document.location.href = `https://${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/signin`
      } else {
        this.$router.push('/signin')
      }
    },
    onIntersect (entries) {
      this.isAtTop = entries[0].isIntersecting
    },
    swipeStart (e) {
      if (typeof e['targetTouches'] !== "undefined"){
          var touch = e.targetTouches[0];
          this.pStart.x = touch.screenX;
          this.pStart.y = touch.screenY;
      } else {
          this.pStart.x = e.screenX;
          this.pStart.y = e.screenY;
      }
    },
    swipeEnd (e) {
      if (typeof e['changedTouches'] !== "undefined"){
          var touch = e.changedTouches[0];
          this.pStop.x = touch.screenX;
          this.pStop.y = touch.screenY;
      } else {
          this.pStop.x = e.screenX;
          this.pStop.y = e.screenY;
      }
      this.swipeCheck()
    },
    onRefresh () {
      if (this.isAtTop && !this.$store.state.ui.modalDialog.visible) {
        // this.fetchSettingsMenu()
        this.isReloading  = true
        setTimeout(() => {
          this.isReloading  = false
        }, 500)
      }
    },
    swipeCheck () {
      var changeY = this.pStart.y - this.pStop.y;
      var changeX = this.pStart.x - this.pStop.x;
      if (this.isPullDown(changeY, changeX) ) {
        this.onRefresh()
      }
    },
    isPullDown (dY, dX) {
      // methods of checking slope, length, direction of line created by swipe action
      let minChangeRatio = 1.5
      if (this.$store.state.mobileapp.device && this.$store.state.mobileapp.device.platform === 'ios') {
        minChangeRatio = 2
      }
      return dY < 0 && (
          (Math.abs(dX) <= 100 && Math.abs(dY) >= 300/minChangeRatio)
          || (Math.abs(dX)/Math.abs(dY) <= 0.3 && dY >= 60/minChangeRatio)
      )
    },
    reload () {
      location.reload()
    }
  },
  wamp: {
    subscribe: {
      'new-update'() {
        this.newUpdate = true
      }
    }
  }
}
</script>

<style lang="scss">
</style>
